export const GA_EVENTS = {
  GO_TO_COMPARE: 'go_to_compare',
  GO_TO_EC_STORE: 'go_to_ec_store',
  GO_TO_PRODUCT: 'go_to_product',
  GO_TO_PS_STORE: 'go_to_ps_store',
  GO_TO_STORES: 'go_to_stores',
  SET_USER_PREFS: 'set_user_preferences',
  SIGN_UP: 'sign_up',
  VIEW_COMPARE: 'view_comparisons',
  VIEW_RECOMMS: 'view_recommendations',
  VIEW_STORES: 'view_stores',
};